"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var tslib_1 = require("tslib");
var ui_icon_1 = require("@hopin-team/ui-icon");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Icon = (0, styled_components_1.default)(ui_icon_1.Icon)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  margin-left: 1rem;\n"], ["\n  position: absolute;\n  margin-left: 1rem;\n"])));
var templateObject_1;
//# sourceMappingURL=icon.js.map